<template>
  <div class="container flex" v-if="isShowAlarmSystem">
    <div id="test" class="flex ml10" v-show="!(modeType == 3)">
      <div class="leftNav">
        <el-input placeholder="请输入关键字按回车查询" clearable v-model="company" @change="searchcomp" prefix-icon="el-icon-search"></el-input>

        <div style="height: 92%;width: 100%; overflow: auto">
          <el-menu default-active="1-1" class="el-menu-vertical-demo">
            <el-submenu :index="String(index + 1)" v-for="(item, index) in companyList1.length ? companyList1 : companyList" :key="index">
              <template slot="title">
                <i :class="'el-icon-folder' || 'el-icon-folder-opened'"></i>
                <span>{{ item.company }}</span>
              </template>
              <el-menu-item @click="checkCop(it)" :index="`${String(index + 1)}-${String(ind + 1)}`" v-for="(it, ind) in item.data" :key="ind">
                <i class="el-icon-document"></i>
                {{ it.area_name }}
              </el-menu-item>
            </el-submenu>
          </el-menu>
        </div>
      </div>
      <div class="acticeBtn">
        <el-tabs v-if="isAlarm || isSomke" v-model="activeName" @tab-click="handleClick" type="card">
          <el-tab-pane v-if="isAlarm" label="报警系统" name="first">
            <div class="content " style="position: relative;">
              <div
                class="canvas"
                ref="can1"
                :style="{
                  transform: 'scale(' + num + ')',
                  position: 'absolute',
                  height: '100%',
                  width: '100%',
                }"
                @mousewheel="suo"
                @mousemove.stop="moveMouse"
                v-if="dwImg"
              >
                <crtmarker ref="aiPanelEditor" :imgUrl="dwImg" :idx="0" />
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane v-if="isSomke" label="无线烟感" name="second">
            <crtmarkVue :isShow="true" :it="it"></crtmarkVue>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
  </div>
</template>
<script>
// import { AIMarker } from "vue-picture-bd-marker";
import crtmarker from '../../components/crtmarker';
import { mapState } from 'vuex';
import crtmarkVue from './tab8-bei.vue';

import { getMapByid } from '../../api/common';
import config from '../../utils/config.js';
if (process.env.NODE_ENV == 'development') {
  //本地
  var wsUrl = config.wsUrltest;
} else if (process.env.NODE_ENV == 'production') {
  //线上
  var wsUrl = config.wsUrl;
}

export default {
  components: { crtmarker, crtmarkVue },
  props: ['nowDevice', 'cpNum'],
  computed: {
    ...mapState(['otherBjList']),
  },
  data() {
    return {
      isShow: true,
      num: 1,
      isdraged: false,
      add: false, //是否新增变化
      typeList: [], // 点位类型
      company: '', // 当前查询的公司
      companyList: [], //公司列表
      upload: {
        updateSupport: 0,
        // 设置上传的请求头部
        headers: { Authorization: 'Bearer ' + this.$local.get('token') },
        // 上传的地址
        url: this.$config.apiUrl + '/device/fireDoorDevice/import',
      },
      companyList1: [], //查询到的公司列表
      qvyuList: [], //区域列表
      pointList: [], //点位列表
      modeType: 1, // 1：平面图 3：全图列表
      tableType: 0, //0:点位列表 1:当前楼梯列表

      rightParams: {
        area_uuid: '',
        c_number: '',
        point_type: 227,
        true_addr: '',
        page: 1,
        number: '',
      },
      // 右侧楼梯列表uuid params
      stairparams: {
        areaUUid: '',
        stairDeviceNo: '',
      },
      rightNum: 10,
      warning: false,
      nowMessage: {},
      curObj: {}, // 当前查看的设备
      form: {}, //最终确定的点位
      dwImg: '',
      activeName: 'first',
      it: null,
      tabindex: 0,
      SmokeSenseList: [],
      isAlarm: true,
      isSomke: true,
      SmoketQuery: {
        area_uuid: '',
        number: '',
      },
      isShowAlarmSystem: false,
    };
  },
  watch: {
    nowDevice(val) {
      log(val, 2123123);
      if (this.curObj && val && val.deviceType == 227) {
        if (this.curObj.areaUUid == this.rightParams.area_uuid) {
          var obj = { ...this.curObj, ...val };
          this.curObj = obj;
          // this.getBigList();
          if (obj.staireId === this.stairparams.stairDeviceNo) {
            this.getRightStairList();
          }
        }
      }
    },
  },
  created() {
    getMapByid(176).then((res) => {
      this.typeList = res.data;
    });

    // 获取单位
    this.$post('/crt/crtmenu', { type: 2 }).then((res) => {
      if (!res.data.length) {
        this.isShowAlarmSystem = false;
        return this.$message.warning('该业务尚未开通，请联系管理员');
      } else {
        this.companyList = res.data;
        this.isShowAlarmSystem = true;
        for (var i = 0; i < this.companyList.length; i++) {
          if (this.companyList[i].data.length) {
            this.checkCop(this.companyList[i].data[0]);
            break;
          }
        }
      }
    });
  },
  methods: {
    handleClick(tab, event) {
      this.tabindex = tab.index;
      if (this.activeName == 'first') {
        return this.checkCop(this.it);
      } else {
        return (this.it = { ...this.it });
      }
    },

    // 搜素单位
    searchcomp() {
      this.companyList1 = [];
      if (!this.company) {
        return;
      }
      if (this.companyList.length) {
        this.companyList.map((item) => {
          if (item.company.indexOf(this.company) > -1) {
            this.companyList1.push(item);
          }
        });
      }
      (this.companyList1.length > 0 ? this.companyList1 : this.companyList)?.forEach((item) => {
        item.data[0] && this.checkCop(item.data[0]);
      });
    },

    //获取点位
    getdwList() {
      this.$post('/crt/crtSmoke', this.rightParams).then((res) => {
        if (res.data) {
          var companylist = [];
          var pointList = [];
          this.rightNum = res.data.count;
          res.data.list.map((item) => {
            var obj1 = {
              number: item.number,
              true_addr: item.device_name,
              point_uuid: item.point_uuid,
              id: item.id,
              isMark: item.x_axis ? true : false,
            };
            var obj2 = {
              tag: item.number,
              tagName: `<div>
                           部位名称:${item.true_addr}<br/>
                             部位号:${item.number}
                        </div>`,

              x: item.x_axis,
              y: item.y_axis,
              type: item.point_type,
              point_uuid: item.point_uuid,
            };
            companylist.push(obj1);
            pointList.push(obj2);
          });
          this.qvyuList = companylist;
          this.pointList = pointList;
          // this.getPoint();
          // this.$refs["aiPanelEditor"]?.remove();

          this.$refs['aiPanelEditor']?.getBiaozhu(this.pointList, this.tabindex);
        } else {
          var companylist = [];
          var pointList = [];
          this.$message.warning('该业务尚未开通，请联系管理员');
          return;
        }
      });
    },

    // 选择区域的点
    checkCop(it) {
      setTimeout(() => {
        this.it = it;
      }, 50);
      // this.$refs["aiPanelEditor"]?.remove();

      this.rightParams.area_uuid = it.area_uuid;
      this.rightParams.page = 1;
      this.rightParams.c_number = it.c_number;
      this.dwImg = it.image_name;
      this.tableType = 0;

      this.$get('/crt/crtSmokeExistence', { area_uuid: it.area_uuid, c_number: '' }).then((res) => {
        this.isAlarm = res.data.wiredSmokeSense;
        this.isSomke = res.data.NotWiredSmokeSense;

        if (res.data.wiredSmokeSense || res.data.NotWiredSmokeSense) {
          if (res.data.wiredSmokeSense && res.data.NotWiredSmokeSense) {
          } else if (res.data.wiredSmokeSense) {
            this.activeName = 'first';
            this.tabindex = 0;
            this.rightParams.point_type = 227;
          } else if (res.data.NotWiredSmokeSense) {
            this.tabindex = 1;
            this.activeName = 'second';
            this.rightParams.point_type = 274;
          }

          switch (this.tabindex) {
            case '0':
              this.rightParams.point_type = 227;
              break;
            case '1':
              this.rightParams.point_type = 274;
              break;
            default:
              // this.tabindex = this.activeName == "first" ? "0" : "1";
              break;
          }

          if (it) this.getdwList();
          // },1000)
        } else {
          this.$message.warning('该业务尚未开通，请联系管理员');
          return;
        }
      });
    },

    //滚轮缩小放大
    suo(v) {
      this.num -= -((v.wheelDelta ? v.wheelDelta : v.deltaY) / 1000);
      if (this.num < 0) {
        this.num = 0.1;
      }
    },

    // 拖拽 目前还未使用
    moveMouse(e) {
      if (!this.isdraged) {
        var ooid = this.$refs.can1; //获取目标元素

        ooid.onmousedown = function(event) {
          var dx = event.clientX - ooid.offsetLeft;
          var dy = event.clientY - ooid.offsetTop;

          ooid.onmousemove = function(event) {
            // console.log(event, 'move cursor to position');
            event = event || window.event;

            var left = event.clientX;
            var top = event.clientY;

            ooid.style.left = left - dx + 'px';
            ooid.style.top = top - dy + 'px';
          };

          ooid.onmouseup = function() {
            ooid.onmousemove = null;
            ooid.onmouseup = null;
          };
        };
      }
    },
  },
};
</script>

<style lang="scss" scoped>
/* 设置滚动条宽度和高度 */
::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  width: 8px; /* 横向滚动条 */
  height: 8px; /* 纵向滚动条 必写 */
}
/* 设置滚动条样式 */
::v-deep .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #dde;
  border-radius: 3px;
}

.acticeBtn {
  width: 100%;
  height: 100%;
}
// 排风机
.controlFire {
  width: 430px;
  .eleButon {
    border: 1px solid #c0c0c0;
    padding: 4px 2px;
    width: 110px;
    border-radius: 15px;
  }

  .eleButonSelect {
    border: 1px solid #78b6ff;
  }

  .closeState {
    display: block;
    margin-top: 2px;
    width: 15px;
    height: 15px;
    background: #f2f2f2;
    box-shadow: 1px 1px #a6a6a6;
    border-radius: 50%;
  }
  .workState {
    background: #399022;
  }
  .stopState {
    background: #d0451b;
  }
  .leftImg {
    width: 280px;
    border: 2px solid #78b6ff;
    padding: 0 10px 10px;
  }
  .rightImg {
    width: 150px;
    border: 2px solid #78b6ff;
    border-left: none;
    padding: 10px;
  }
  .secondControl {
    // height: 90px;
    border: 2px solid #78b6ff;
    border-top: none;
    padding: 10px;

    .buttonOpen {
      background: repeating-radial-gradient(circle at center, #a1f1af, #399022);
    }
    .buttonClose {
      background: repeating-radial-gradient(circle at center, #ffe4d6, 30%, #eb0000);
    }
  }
}

.selectVideo {
  border: solid 2px red;
  height: 500px;
  width: 600px;
  position: relative;
}
::v-deep .selected {
  z-index: 99999;
}
::v-deep .g-image-op {
  background: #fff;
  border: 1px solid #ccc;
  bottom: 110%;
  display: none;
}
::v-deep .g-image-op-del {
  display: none;
}
::v-deep .g-image-op-content {
  height: auto;
}
::v-deep .annotation {
  background: #000;
  border: none;
  /* animation: dianmove 0.5s infinite; */
  border-radius: 50%;
  /* border: none; */
}
::v-deep .animate {
  animation: warningmove 0.6s infinite;
  position: absolute !important;
  /* z-index: 999999; */
}

@keyframes warningmove {
  from {
    background: yellow;
  }
  to {
    background: #ed1c24;
  }
}
.canvas {
  display: flex;
  // align-items: center;
  width: 50%;
}
.container {
  height: 100%;
  max-height: 80vh;
  width: 100%;
  justify-content: space-around;
  flex-direction: column;
  .leftNav {
    height: 100%;
    width: 31.25rem;
  }
  #test {
    height: 100%;
    .el-dialog__body {
      padding: 10px 20px !important;
    }
    .content {
      width: 70%;
      height: 100%;
      background: #000;
      display: flex;
      align-items: center;
      overflow: hidden;
      position: relative;
      border: 1px solid gray;
    }
  }
}
::v-deep .el-tab-pane {
  width: 100%;
  height: 43.75rem;
  // margin: auto 0;
  display: flex;
  justify-content: space-around;
}
.acticeBtn {
  // margin-top: 0.625rem;
  margin-left: 10px;
}
::v-deep .el-menu-item {
  width: 100%;
}
::v-deep .el-menu-item .is-active {
  width: 20%;
}
#myBiaoZhu0 {
  width: 50% !important;
}
</style>
